<template>
  <div>
    <p class="section-title">{{ sectionTitle }}</p>

    <div v-for="info in infos" :key="info.title">
      <p class="title"><b v-html="info.title"></b></p>
      <p>{{ info.dateRange }}</p>
      <ul>
        <li
          v-for="description in info.descriptions"
          :key="description"
          v-html="description"
        />
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumeDescriptionSection',
  props: {
    infos: {
      type: Array,
      required: true,
      default: () => []
    },
    sectionTitle: {
      type: String,
      required: true,
      default: "PROJECTS"
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  font-size: 14px;
}

p {
  margin: 0;
  font-size: 14px;

  &.section-title {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
  }

  &.title {
    font-size: 16px;
  }
}
</style>
